import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { APP_NAME } from "@/lib/branding";

export default function CTAFinal() {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    const params = new URLSearchParams({ plan: "business" });
    if (email.trim()) params.set("email", email.trim());
    navigate(`/register?${params.toString()}`);
  };

  return (
    <section className="py-20 lg:py-28 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="relative rounded-3xl bg-[#0B0F17] text-white p-8 sm:p-14 lg:p-20 overflow-hidden">
          {/* Background grid */}
          <div
            className="absolute inset-0 opacity-[0.08]"
            style={{
              backgroundImage:
                "linear-gradient(#FFF 1px, transparent 1px), linear-gradient(90deg, #FFF 1px, transparent 1px)",
              backgroundSize: "48px 48px",
              maskImage:
                "radial-gradient(ellipse 60% 80% at 50% 50%, #000 30%, transparent 100%)",
              WebkitMaskImage:
                "radial-gradient(ellipse 60% 80% at 50% 50%, #000 30%, transparent 100%)",
            }}
          />
          <div className="absolute -top-32 -right-32 h-96 w-96 rounded-full bg-indigo-500/20 blur-3xl" />
          <div className="absolute -bottom-32 -left-32 h-96 w-96 rounded-full bg-emerald-500/10 blur-3xl" />

          <div className="relative max-w-2xl">
            <div className="text-xs font-semibold uppercase tracking-widest text-indigo-300">
              Prêt en 2 minutes
            </div>
            <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight">
              Prêt à transformer votre gestion financière ?
            </h2>
            <p className="mt-4 text-lg text-slate-300">
              Rejoignez les +2 500 entreprises et 400 cabinets qui pilotent avec{" "}
              {APP_NAME}. 14 jours gratuits, aucune CB, migration assistée.
            </p>

            <form
              onSubmit={submit}
              className="mt-8 flex flex-col sm:flex-row gap-3 max-w-lg"
              data-testid="cta-final-form"
            >
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Votre email professionnel"
                data-testid="cta-final-email-input"
                className="flex-1 h-12 px-4 rounded-lg bg-white/10 border border-white/20 text-white placeholder:text-slate-400 focus:outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-500/30"
              />
              <button
                type="submit"
                data-testid="cta-final-submit-button"
                className="group inline-flex items-center justify-center gap-2 h-12 px-6 rounded-lg bg-white text-[#0B0F17] font-semibold text-sm hover:bg-slate-100 shadow-lg transition-all whitespace-nowrap"
              >
                Commencer gratuitement
                <ArrowRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
              </button>
            </form>

            <div className="mt-6 flex items-center gap-2 text-xs text-slate-400">
              <ShieldCheck className="h-3.5 w-3.5 text-emerald-400" />
              Hébergé en France · RGPD · SecNumCloud · ISO 27001 en cours
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
